import { render, staticRenderFns } from "./FilterRulePage.vue?vue&type=template&id=066588b9&"
import script from "./FilterRulePage.vue?vue&type=script&lang=js&"
export * from "./FilterRulePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports